import { Middleware } from "redux";
import { addToLoading, removeFromLoading } from "./actions";

const isPending = (type: string) => type.endsWith("_PENDING");
const isFailed = (type: string) => type.endsWith("_REJECTED");
const isFulfilled = (type: string) => type.endsWith("_FULFILLED");
const getBaseType = (type: string) => {
    if (isPending(type) || isFulfilled(type) || isFailed(type)) {
        return type.substring(0, type.lastIndexOf("_"));
    }

    return type;
};

/**
 * Middleware will listen for promise middleware action types endings (_PENDING, _REJECTED, _FULFILLED)
 * and keep track of what actionTypes are currently pending.
 *
 * This can be used further in views to display loading spinners/bars
 */
export default function loadingMiddleware(): Middleware {
    return (store) => (next) => (action) => {
        if (isPending(action.type)) {
            store.dispatch(addToLoading(getBaseType(action.type)));
        }

        if (isFulfilled(action.type) || isFailed(action.type)) {
            store.dispatch(removeFromLoading(getBaseType(action.type)));
        }

        return next(action);
    };
}
